// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".KqGtDh2JlbLiv5IAEBro {\n\tpadding-left: 8px;\n}\n\n.QJv7QfXt3jpx8Y3MX69U {\n\tfont-size: 14px;\n}\n", "",{"version":3,"sources":["webpack://./client/src/components/BunkersTable/BunkersTable.module.css"],"names":[],"mappings":"AAAA;CACC,iBAAiB;AAClB;;AAEA;CACC,eAAe;AAChB","sourcesContent":[".addNewButtonContainer {\n\tpadding-left: 8px;\n}\n\n.buttonIcon {\n\tfont-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"addNewButtonContainer": "KqGtDh2JlbLiv5IAEBro",
	"buttonIcon": "QJv7QfXt3jpx8Y3MX69U"
};
export default ___CSS_LOADER_EXPORT___;
